<script>
    import { Child } from 'pym.js';
    import Graphic from './Graphic.svelte';
    import pkg from '../package.json';
    import meta from './data/meta.json';
    import { onMount } from 'svelte';
    import manageParams from './utils/manageParams.js';
    
    let pymChild = $state();
    let width = $state(600);
    let height = $state(0);  
    let containerElement = $state();
    let data = $state(null);

    const params = manageParams();

    const dataUrl = 'https://ix.cnn.io/data/el-nino-index/roni.json';

    const copy = { legend: 'Relative Oceanic Niño Index (°C)' };
    
    function handlePymResize(newWidth) {
      width = newWidth;
    }
    
    function sendHeight() {
      if (pymChild) {
        pymChild.sendHeight();
      }
    }

    // Fetch the Relative Oceanic Niño Index (RONI), monthly values back to 1949.
    fetch(dataUrl)
      .then(response => response.json())
      .then(d => {
        data = d.map(row => ({
          year: row.year,
          month: row.month,
          roni: row.roni,
          date: row.dt,
        }));
      })
      .catch(error => {
        console.error('Error fetching RONI data:', error);
      });
    
    // REACT TO HEIGHT CHANGES using $effect
    $effect(() => {
      if (pymChild && height > 0) {
        sendHeight();
      }
    });

    onMount(() => {
      pymChild = new Child({ 
        renderCallback: handlePymResize, 
        id: pkg.name 
      });

      // Add app class to meta container if app param is true
      if (params.app === 'true') {
        document.querySelector('#meta')?.classList.add('app');
      }
      
      // document.querySelector('h1.headline').innerHTML = meta.headline;
      // document.querySelector('h2.subhed').innerHTML = meta.subhed;

      if (containerElement) {
        const containerWidth = containerElement.clientWidth;
        if (containerWidth && containerWidth !== width) {
          width = containerWidth;
        }
      }
      
      return () => {
        if (pymChild) {
          pymChild.remove();
        }
      };
    });

    $inspect(data);
  </script>
  
  <!-- BIND HEIGHT HERE -->
  <div bind:this={containerElement} bind:clientHeight={height} bind:clientWidth={width} class="app-container" class:app={params.app === 'true'}>
    <Graphic {width} {data} {copy} {params} />
  </div>
  
  <style>
    .app-container {
      width: 100%;
    }
  </style>
